import { STATUS_COLORS, STATUS_LABELS } from './types';

import type { TenantStatus } from './types';

/**
 * TenantStatusBadge — pill colorido para status de lifecycle de Tenant (ADR-111).
 *
 * 7 estados canônicos + inactive legacy.
 * D-B: gate parent — badge read-only, sem capability gate próprio.
 */
export function TenantStatusBadge({ status }: { status: TenantStatus }): JSX.Element {
  const colors = STATUS_COLORS[status] ?? STATUS_COLORS.inactive;
  const label = STATUS_LABELS[status] ?? status;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 8px',
        borderRadius: 20,
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.bg,
        color: colors.fg,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: colors.fg,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
}
